<div class="deposit-product-modal" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <header class="modal-header" cdkDragHandle>
    <img
      class="modal-logo"
      src="assets/images/new-images/logo-2.png"
      routerLink="/dashboard"
      alt="Aquila"
    />
    <h2 class="modal-title">
      <span *ngIf="isViewMode" i18n="@@edit">Edit</span>
      <span *ngIf="!isViewMode" i18n="@@new">New</span>
      <span i18n="@@deposite_product">Deposit Product</span>
    </h2>
    <button
      mat-icon-button
      class="modal-close"
      type="button"
      (click)="cancel()"
      aria-label="Close dialog"
      i18n-aria-label="@@close_dialog"
    >
      <mat-icon>highlight_off</mat-icon>
    </button>
  </header>

  <main class="deposit-modal-content">
    <section
      class="product-type-row"
      aria-label="Product type"
      i18n-aria-label="@@deposit_product_type"
    >
      <div class="type-label">
        <img src="assets/icons/deposit-product/type.svg" alt="" />
        <span i18n="@@deposit_product_type">Type <strong>*</strong></span>
      </div>
      <mat-form-field appearance="outline" class="design-material-field">
        <mat-select [formControl]="productTypeControl" panelClass="deposit-product-select-panel">
          <mat-option value="DEPOSIT_ACCOUNT" i18n="@@deposit_account">Deposit Account</mat-option>
          <mat-option value="FIXED_DEPOSIT" i18n="@@fixed_deposit_investment_account"
            >Fixed Deposit/Investment Account</mat-option
          >
          <mat-option value="RECURRING_TARGETED" i18n="@@recurring_targeted_savings"
            >Recurring/Targeted Savings</mat-option
          >
        </mat-select>
      </mat-form-field>
    </section>

    <section class="product-basics" [formGroup]="basicForm">
      <label class="field">
        <span i18n="@@product_name">Product Name <strong>*</strong></span>
        <mat-form-field appearance="outline" class="design-material-field">
          <input matInput type="text" appRemoveSpaces appTitleCase formControlName="name" />
        </mat-form-field>
      </label>
      <label class="field">
        <span i18n="@@columnCode">Code <strong>*</strong></span>
        <mat-form-field appearance="outline" class="design-material-field">
          <input matInput type="text" appRemoveSpaces formControlName="code" />
        </mat-form-field>
      </label>
      <label class="field">
        <span i18n="@@description">Description</span>
        <mat-form-field appearance="outline" class="design-material-field">
          <input
            matInput
            type="text"
            appRemoveSpaces
            appSentenceCase
            formControlName="description"
          />
        </mat-form-field>
      </label>
      <label class="field">
        <span i18n="@@deposit_product_currency_required">Currency <strong>*</strong></span>
        <mat-form-field appearance="outline" class="design-material-field">
          <mat-select formControlName="currency">
            <mat-option *ngFor="let currency of currencies" [value]="currency.code">
              {{ currency.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </label>
    </section>

    <section class="configuration-layout" *ngIf="selectedProductType === 'DEPOSIT_ACCOUNT'">
      <div class="rate-panels">
        <article class="rate-card">
          <h3 i18n="@@interest_expense">Interest Expense</h3>
          <div class="rate-card-scroll">
            <div class="rate-grid" [formGroup]="interestExpenseForm">
            <span></span>
            <span class="column-title" i18n="@@deposit_product_interest_rate"
              >Interest Rate (%)</span
            >
            <span class="column-title" i18n="@@deposit_product_compounding_frequency"
              >Compounding Frequency</span
            >
            <span class="column-title" i18n="@@deposit_product_posting_period"
              >Posting Period</span
            >
            <span class="column-title" i18n="@@deposit_product_interest_calculation"
              >Interest Calculation</span
            >

            <span></span>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact rate-header-select period-label-select"
            >
              <mat-label i18n="@@period">Period</mat-label>
              <mat-select formControlName="interestPeriodUnit">
                <mat-option value="DAY" i18n="@@dayOption">Day</mat-option>
                <mat-option value="WEEK" i18n="@@weekOption">Week</mat-option>
                <mat-option value="MONTH" i18n="@@monthOption">Month</mat-option>
                <mat-option value="YEAR" i18n="@@yearOption">Year</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact rate-header-select period-label-select"
            >
              <mat-label i18n="@@period">Period</mat-label>
              <mat-select formControlName="compoundingPeriodUnit">
                <mat-option value="DAY" i18n="@@dayOption">Day</mat-option>
                <mat-option value="WEEK" i18n="@@weekOption">Week</mat-option>
                <mat-option value="MONTH" i18n="@@monthOption">Month</mat-option>
                <mat-option value="YEAR" i18n="@@yearOption">Year</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact rate-header-select period-label-select"
            >
              <mat-label i18n="@@period">Period</mat-label>
              <mat-select formControlName="interestPostingPeriodUnit">
                <mat-option value="DAY" i18n="@@dayOption">Day</mat-option>
                <mat-option value="WEEK" i18n="@@weekOption">Week</mat-option>
                <mat-option value="MONTH" i18n="@@monthOption">Month</mat-option>
                <mat-option value="YEAR" i18n="@@yearOption">Year</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact rate-header-select"
            >
              <mat-select formControlName="interestCalculationType">
                <mat-option value="AVERAGE_BALANCE" i18n="@@average_balance"
                  >Average Balance</mat-option
                >
                <mat-option value="MINIMUM_BALANCE" i18n="@@minimum_balance"
                  >Minimum Balance</mat-option
                >
              </mat-select>
            </mat-form-field>

            <span class="row-title" i18n="@@deposit_product_default_required"
              >Default <strong>*</strong></span
            >
            <mat-form-field appearance="outline" class="design-material-field compact"
              ><input matInput type="text" appDecimalNumbers [allowZero]="true" inputmode="decimal" formControlName="interestRate"
            /></mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact mirrored-rate-field"
            >
              <input matInput readonly [value]="getPeriodUnitLabel('compoundingPeriodUnit')" />
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact mirrored-rate-field"
            >
              <input matInput readonly [value]="getPeriodUnitLabel('interestPostingPeriodUnit')" />
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact mirrored-rate-field"
            >
              <input
                matInput
                readonly
                [value]="getCalculationTypeLabel('interestCalculationType')"
              />
            </mat-form-field>

            <span class="row-title" i18n="@@deposit_product_minimum_required"
              >Minimum <strong>*</strong></span
            >
            <mat-form-field appearance="outline" class="design-material-field compact"
              ><input matInput type="text" appDecimalNumbers [allowZero]="true" inputmode="decimal" formControlName="minimumInterestRate"
            /></mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact mirrored-rate-field"
              ><input matInput readonly [value]="getPeriodUnitLabel('compoundingPeriodUnit')"
            /></mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact mirrored-rate-field"
              ><input matInput readonly [value]="getPeriodUnitLabel('interestPostingPeriodUnit')"
            /></mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact mirrored-rate-field"
              ><input
                matInput
                readonly
                [value]="getCalculationTypeLabel('interestCalculationType')"
            /></mat-form-field>

            <span class="row-title" i18n="@@deposit_product_maximum_required"
              >Maximum <strong>*</strong></span
            >
            <mat-form-field appearance="outline" class="design-material-field compact"
              ><input matInput type="text" appDecimalNumbers [allowZero]="true" inputmode="decimal" formControlName="maximumInterestRate"
            /></mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact mirrored-rate-field"
              ><input matInput readonly [value]="getPeriodUnitLabel('compoundingPeriodUnit')"
            /></mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact mirrored-rate-field"
              ><input matInput readonly [value]="getPeriodUnitLabel('interestPostingPeriodUnit')"
            /></mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact mirrored-rate-field"
              ><input
                matInput
                readonly
                [value]="getCalculationTypeLabel('interestCalculationType')"
            /></mat-form-field>
            </div>
          </div>
        </article>

        <article class="rate-card overdraft-card">
          <div class="card-heading-row">
            <label class="toggle-label">
              <span i18n="@@allow_overdraft">Allow Overdraft</span>
              <mat-slide-toggle
                class="figma-toggle"
                [formControl]="allowOverdraftControl"
              ></mat-slide-toggle>
            </label>
            <label class="limit-field">
              <span i18n="@@overdraft_limit">Overdraft Limit</span>
              <mat-form-field appearance="outline" class="design-material-field">
                <input
                  matInput
                  type="text"
                  appCurrency
                  [formControl]="overdraftLimitControl"
                  (blur)="invalidateMinimumBalance()"
                />
              </mat-form-field>
            </label>
          </div>
          <hr class="border-[#979797]" />

          <div class="rate-card-scroll">
            <div class="rate-grid" [formGroup]="interestExpenseForm">
            <span></span>
            <span class="column-title" i18n="@@deposit_product_interest_rate"
              >Interest Rate (%)</span
            >
            <span class="column-title" i18n="@@deposit_product_compounding_frequency"
              >Compounding Frequency</span
            >
            <span class="column-title" i18n="@@deposit_product_posting_period"
              >Posting Period</span
            >
            <span class="column-title" i18n="@@deposit_product_interest_calculation"
              >Interest Calculation</span
            >

            <span></span>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact rate-header-select period-label-select"
            >
              <mat-label i18n="@@period">Period</mat-label>
              <mat-select formControlName="overdraftInterestPeriodUnit">
                <mat-option value="DAY" i18n="@@dayOption">Day</mat-option>
                <mat-option value="WEEK" i18n="@@weekOption">Week</mat-option>
                <mat-option value="MONTH" i18n="@@monthOption">Month</mat-option>
                <mat-option value="YEAR" i18n="@@yearOption">Year</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact rate-header-select period-label-select"
            >
              <mat-label i18n="@@period">Period</mat-label>
              <mat-select formControlName="overdraftCompoundingPeriodUnit">
                <mat-option value="DAY" i18n="@@dayOption">Day</mat-option>
                <mat-option value="WEEK" i18n="@@weekOption">Week</mat-option>
                <mat-option value="MONTH" i18n="@@monthOption">Month</mat-option>
                <mat-option value="YEAR" i18n="@@yearOption">Year</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact rate-header-select period-label-select"
            >
              <mat-label i18n="@@period">Period</mat-label>
              <mat-select formControlName="overdraftInterestPostingPeriodUnit">
                <mat-option value="DAY" i18n="@@dayOption">Day</mat-option>
                <mat-option value="WEEK" i18n="@@weekOption">Week</mat-option>
                <mat-option value="MONTH" i18n="@@monthOption">Month</mat-option>
                <mat-option value="YEAR" i18n="@@yearOption">Year</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact rate-header-select"
            >
              <mat-select formControlName="overdraftInterestCalculationType">
                <mat-option value="AVERAGE_BALANCE" i18n="@@average_balance"
                  >Average Balance</mat-option
                >
                <mat-option value="MINIMUM_BALANCE" i18n="@@minimum_balance"
                  >Minimum Balance</mat-option
                >
              </mat-select>
            </mat-form-field>

            <span class="row-title" i18n="@@deposit_product_default_required"
              >Default <strong>*</strong></span
            >
            <mat-form-field appearance="outline" class="design-material-field compact"
              ><input matInput type="text" appDecimalNumbers [allowZero]="true" inputmode="decimal" formControlName="overdraftInterestRate"
            /></mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact mirrored-rate-field"
            >
              <input
                matInput
                readonly
                [value]="getPeriodUnitLabel('overdraftCompoundingPeriodUnit')"
              />
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact mirrored-rate-field"
            >
              <input
                matInput
                readonly
                [value]="getPeriodUnitLabel('overdraftInterestPostingPeriodUnit')"
              />
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact mirrored-rate-field"
            >
              <input
                matInput
                readonly
                [value]="getCalculationTypeLabel('overdraftInterestCalculationType')"
              />
            </mat-form-field>

            <span class="row-title" i18n="@@deposit_product_minimum_required"
              >Minimum <strong>*</strong></span
            >
            <mat-form-field appearance="outline" class="design-material-field compact"
              ><input matInput type="text" appDecimalNumbers [allowZero]="true" inputmode="decimal" formControlName="minimumOverdraftInterestRate"
            /></mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact mirrored-rate-field"
              ><input
                matInput
                readonly
                [value]="getPeriodUnitLabel('overdraftCompoundingPeriodUnit')"
            /></mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact mirrored-rate-field"
              ><input
                matInput
                readonly
                [value]="getPeriodUnitLabel('overdraftInterestPostingPeriodUnit')"
            /></mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact mirrored-rate-field"
              ><input
                matInput
                readonly
                [value]="getCalculationTypeLabel('overdraftInterestCalculationType')"
            /></mat-form-field>

            <span class="row-title" i18n="@@deposit_product_maximum_required"
              >Maximum <strong>*</strong></span
            >
            <mat-form-field appearance="outline" class="design-material-field compact"
              ><input matInput type="text" appDecimalNumbers [allowZero]="true" inputmode="decimal" formControlName="maximumOverdraftInterestRate"
            /></mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact mirrored-rate-field"
              ><input
                matInput
                readonly
                [value]="getPeriodUnitLabel('overdraftCompoundingPeriodUnit')"
            /></mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact mirrored-rate-field"
              ><input
                matInput
                readonly
                [value]="getPeriodUnitLabel('overdraftInterestPostingPeriodUnit')"
            /></mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact mirrored-rate-field"
              ><input
                matInput
                readonly
                [value]="getCalculationTypeLabel('overdraftInterestCalculationType')"
            /></mat-form-field>
            </div>
          </div>
        </article>
      </div>

      <div class="side-panels">
        <article class="other-info-card">
          <h3 i18n="@@limits">Limits</h3>
          <div class="limits-fields" [formGroup]="otherInfoForm">
            <label>
              <span i18n="@@deposit_product_minimum_balance_required"
                >Minimum Balance <strong>*</strong></span
              >
              <mat-form-field appearance="outline" class="design-material-field"
                ><input
                  matInput
                  type="text"
                  appCurrency
                  formControlName="openingBalance"
                  (blur)="invalidateOverdraftLimit()"
              /></mat-form-field>
            </label>
            <label>
              <span i18n="@@transfer_limit">Transfer Limit</span>
              <mat-form-field appearance="outline" class="design-material-field"
                ><input
                  matInput
                  type="text"
                  appCurrency
                  formControlName="transferLimit"
                  (blur)="validateTransferLimits()"
              /></mat-form-field>
            </label>
            <label>
              <span i18n="@@daily_transfer_limit">Daily Transfer Limit</span>
              <mat-form-field appearance="outline" class="design-material-field"
                ><input
                  matInput
                  type="text"
                  appCurrency
                  formControlName="dailyTransferLimit"
                  (blur)="validateTransferLimits()"
              /></mat-form-field>
            </label>
            <label>
              <span i18n="@@dormancy_threshold_days">Dormancy Threshold (Days)</span>
              <mat-form-field appearance="outline" class="design-material-field"
                ><input
                  matInput
                  type="text"
                  appStrictNumbers
                  [formControl]="dormancyThresholdControl"
              /></mat-form-field>
            </label>
          </div>
        </article>

        <article class="calculator-card" [formGroup]="interestExpenseForm">
          <p>
            <strong i18n="@@live_calculator">Live Calculator</strong>
            <span i18n="@@based_on_current_configuration">(based on current configuration)</span>
          </p>
          <label
            ><span i18n="@@deposit_product_average_balance_required"
              >Average Balance <strong>*</strong></span
            ><mat-form-field appearance="outline" class="design-material-field"
              ><input
                matInput
                type="text"
                appCurrency
                formControlName="calculatorAverageBalance"
              /></mat-form-field
          ></label>
          <label
            ><span i18n="@@deposit_product_interest_rate_required"
              >Interest Rate <strong>*</strong></span
            ><mat-form-field appearance="outline" class="design-material-field calculator-field"
              ><input matInput type="text" appDecimalNumbers [allowZero]="true" inputmode="decimal" formControlName="calculatorInterestRate" /></mat-form-field
          ></label>
          <label
            ><span i18n="@@deposit_product_period_required">Period <strong>*</strong></span
            ><mat-form-field
              appearance="outline"
              class="design-material-field calculator-field readonly-period-select"
              ><mat-select formControlName="interestPostingPeriodUnit">
                <mat-option value="DAY" i18n="@@deposit_product_per_day">Per Day</mat-option>
                <mat-option value="WEEK" i18n="@@deposit_product_per_week">Per Week</mat-option>
                <mat-option value="MONTH" i18n="@@deposit_product_per_month">Per Month</mat-option>
                <mat-option value="YEAR" i18n="@@deposit_product_per_year">Per Year</mat-option>
              </mat-select></mat-form-field
          ></label>
          <label
            ><span i18n="@@projected_interest">Projected Interest</span
            ><mat-form-field
              appearance="outline"
              class="design-material-field projected-interest-field"
              ><input
                matInput
                type="text"
                readonly
                [value]="formatProjectionAmount(depositProjectedInterest)"
              /></mat-form-field
          ></label>
        </article>
      </div>
    </section>

    <section
      class="variant-product-layout fixed-product-layout"
      *ngIf="selectedProductType === 'FIXED_DEPOSIT'"
      [formGroup]="fixedDepositForm"
    >
      <div class="variant-primary-grid fixed-primary-grid">
        <div class="variant-left-column">
          <article class="tier-card fixed-tier-card">
            <div class="tier-grid fixed-tier-grid">
              <span></span>
              <span class="tier-heading" i18n="@@amount">Amount</span>
              <span class="tier-heading" i18n="@@duration">Duration</span>
              <span class="tier-heading" i18n="@@interest_rate_percent"
                >Interest<br />Rate (%)</span
              >
              <span class="tier-heading" i18n="@@compounding_frequency"
                >Compounding<br />Frequency</span
              >
              <span class="tier-heading" i18n="@@interest_payout">Interest<br />Payout</span>

              <span></span>
              <span class="tier-unit">{{ currencyCode }}</span>
              <mat-form-field
              appearance="outline"
              class="design-material-field compact variant-header-select period-label-select"
            >
              <mat-label i18n="@@tenure">Tenure</mat-label>
              <mat-select formControlName="durationPeriodUnit">
                <mat-option *ngFor="let unit of tenureUnitOptions" [value]="unit.value">{{ unit.label }}</mat-option>
              </mat-select>
            </mat-form-field>
              <mat-form-field
                appearance="outline"
                class="design-material-field compact variant-header-select period-label-select"
              >
                <mat-label i18n="@@period">Period</mat-label>
                <mat-select formControlName="interestRatePeriodUnit">
                <mat-option *ngFor="let unit of interestPeriodOptions" [value]="unit.value">{{ unit.label }}</mat-option>
              </mat-select>
              </mat-form-field>
              <mat-form-field
                appearance="outline"
                class="design-material-field compact variant-header-select period-label-select"
              >
                <mat-label i18n="@@period">Period</mat-label>
                <mat-select formControlName="compoundingFrequency">
                <mat-option *ngFor="let unit of fixedCompoundingOptions" [value]="unit.value">{{ unit.label }}</mat-option>
              </mat-select>
              </mat-form-field>
              <mat-form-field
                appearance="outline"
                class="design-material-field compact variant-header-select period-label-select"
              >
                <mat-label i18n="@@period">Period</mat-label>
                <mat-select formControlName="interestPayout">
                  <mat-option value="MONTH" i18n="@@monthOption"
                    >Month</mat-option
                  >
                  <mat-option value="QUARTER" i18n="@@quarter">Quarter</mat-option>
                  <mat-option value="MATURITY" i18n="@@maturity">Maturity</mat-option>
                </mat-select>
              </mat-form-field>

              <ng-container *ngFor="let row of fixedTierRows">
                <span class="tier-row-label">{{ tierRowLabel(row.label) }} <strong>*</strong></span>
                <mat-form-field appearance="outline" class="design-material-field"
                  ><input matInput appCurrency [formControlName]="row.amount"
                /></mat-form-field>
                <mat-form-field appearance="outline" class="design-material-field"
                  ><input matInput appStrictNumbers [formControlName]="row.duration"
                /></mat-form-field>
                <mat-form-field appearance="outline" class="design-material-field"
                  ><input matInput appDecimalNumbers [allowZero]="true" inputmode="decimal" [formControlName]="row.rate"
                /></mat-form-field>
                <mat-form-field
                  appearance="outline"
                  class="design-material-field variant-mirrored-field"
                >
                  <input
                    matInput
                    readonly
                    [value]="getFixedPeriodUnitLabel('compoundingFrequency')"
                  />
                </mat-form-field>
                <mat-form-field
                  appearance="outline"
                  class="design-material-field variant-mirrored-field"
                >
                  <input matInput readonly [value]="getFixedPayoutLabel()" />
                </mat-form-field>
              </ng-container>
            </div>
          </article>

          <div class="fixed-policy-grid">
            <article class="policy-card maturity-policy">
              <h3 i18n="@@maturity_instructions">Maturity Instructions</h3>
              <label class="toggle-row">
                <div class="mt-2">
                  <span i18n="@@auto_rollover_at_maturity"
                    >Auto-Rollover at Maturity <strong>*</strong></span
                  >
                  <small i18n="@@maturity_instruction_hint"
                    >If customer gives no instruction before maturity</small
                  >
                </div>
                <mat-slide-toggle
                  class="figma-toggle"
                  formControlName="autoRollover"
                ></mat-slide-toggle>
              </label>
              <div class="policy-fields two-columns">
                <label class="field"
                  ><span i18n="@@rollover_basis">Rollover Basis <strong>*</strong></span
                  ><mat-form-field appearance="outline" class="design-material-field"
                    ><mat-select formControlName="rolloverBasis"
                      ><mat-option value="PRINCIPAL_AND_INTEREST" i18n="@@principal_and_interest"
                        >Principal + Interest</mat-option
                      ><mat-option value="PRINCIPAL" i18n="@@principal_only"
                        >Principal Only</mat-option
                      ></mat-select
                    ></mat-form-field
                  ></label
                >
                <label class="field">
                  <span i18n="@@grace_period">Grace Period <strong>*</strong></span>
                  <mat-form-field appearance="outline" class="design-material-field"
                    ><input matInput appStrictNumbers formControlName="gracePeriod"
                  /></mat-form-field>
                  <small i18n="@@days_after_maturity_before_rollover"
                    >Days after maturity, before rollover</small
                  >
                </label>
              </div>
            </article>

            <article class="policy-card premature-withdrawal-policy">
              <h3 i18n="@@premature_withdrawal">Premature Withdrawal <strong>*</strong></h3>
              <label class="toggle-row">
                <div class="mt-2">
                  <span i18n="@@allow_premature_withdrawal"
                    >Allow Premature Withdrawal <strong>*</strong></span
                  >
                  <small i18n="@@premature_withdrawal_hint"
                    >Customer can liquidate before maturity</small
                  >
                </div>
                <mat-slide-toggle
                  class="figma-toggle"
                  formControlName="allowPrematureWithdrawal"
                ></mat-slide-toggle>
              </label>
              <div class="policy-fields three-columns">
                <label class="field">
                  <span i18n="@@minimum_holding_period"
                    >Minimum Holding Period <strong>*</strong></span
                  >
                  <mat-form-field appearance="outline" class="design-material-field"
                    ><input matInput appStrictNumbers formControlName="minimumHoldingPeriod"
                  /></mat-form-field>
                  <small i18n="@@days_before_withdrawal_is_allowed"
                    >Days before withdrawal is allowed</small
                  >
                </label>
                <label class="field"
                  ><span i18n="@@penalty_on_interest">Penalty on Interest <strong>*</strong></span
                  ><mat-form-field appearance="outline" class="design-material-field"
                    ><input matInput formControlName="penaltyOnInterest" /></mat-form-field
                ></label>
                <label class="field">
                  <span i18n="@@notice_period">Notice Period</span>
                  <mat-form-field appearance="outline" class="design-material-field"
                    ><input matInput appStrictNumbers formControlName="noticePeriod"
                  /></mat-form-field>
                  <small i18n="@@days_notice_before_payout">Days' notice before payout</small>
                </label>
              </div>
            </article>
          </div>
        </div>

        <article class="calculator-card fixed-calculator">
          <p>
            <strong i18n="@@live_calculator">Live Calculator</strong
            ><span i18n="@@based_on_current_configuration" class="text-[10px]"
              >(based on current configuration)</span
            >
          </p>
          <label
            ><span i18n="@@amount_required">Amount <strong>*</strong></span
            ><mat-form-field appearance="outline" class="design-material-field calculator-field"
              ><input matInput appCurrency formControlName="calculatorAmount" /></mat-form-field
          ></label>
          <label
            ><span i18n="@@duration_required">Duration ({{ fixedTenureUnitLabel() }}) <strong>*</strong></span
            ><mat-form-field appearance="outline" class="design-material-field calculator-field"
              ><input
                matInput
                appDecimalNumbers
                [allowZero]="true"
                inputmode="decimal"
                formControlName="calculatorDuration" /></mat-form-field
          ></label>
          <label
            ><span i18n="@@interest_rate_required">Interest Rate <strong>*</strong></span
            ><mat-form-field appearance="outline" class="design-material-field calculator-field"
              ><input matInput appDecimalNumbers [allowZero]="true" inputmode="decimal" formControlName="calculatorInterestRate" /></mat-form-field
          ></label>
          <label
            ><span i18n="@@early_withdrawal_day">Early Withdrawal Day</span
            ><mat-form-field appearance="outline" class="design-material-field calculator-field"
              ><input
                matInput
                appStrictNumbers
                formControlName="earlyWithdrawalDay" /></mat-form-field
          ></label>
          <label
            ><span i18n="@@interest_to_maturity">Interest to Maturity</span
            ><mat-form-field
              appearance="outline"
              class="design-material-field projected-interest-field"
              ><input
                matInput
                readonly
                [value]="formatProjectionAmount(fixedDepositCalculatorResult?.interestToMaturity)"
              /></mat-form-field
          ></label>
          <label
            ><span i18n="@@maturity_value">Maturity Value</span
            ><mat-form-field
              appearance="outline"
              class="design-material-field projected-interest-field"
              ><input
                matInput
                readonly
                [value]="formatProjectionAmount(fixedDepositCalculatorResult?.maturityValue)"
              /></mat-form-field
          ></label>
          <label
            ><span i18n="@@early_withdrawal_payout">Early Withdrawal Payout</span
            ><mat-form-field
              appearance="outline"
              class="design-material-field projected-interest-field"
              ><input
                matInput
                readonly
                [value]="formatProjectionAmount(fixedDepositCalculatorResult?.earlyWithdrawalPayout)"
              /></mat-form-field
          ></label>
        </article>
      </div>
    </section>

    <section
      class="variant-product-layout recurring-product-layout"
      *ngIf="selectedProductType === 'RECURRING_TARGETED' && recurringSavingsForm"
      [formGroup]="recurringSavingsForm"
    >
      <div class="recurring-primary-grid">
        <article class="tier-card recurring-tier-card">
          <div class="tier-grid recurring-tier-grid">
            <span></span>
            <span class="tier-heading" i18n="@@target_amount">Target<br />Amount</span>
            <span class="tier-heading" i18n="@@duration">Duration</span>
            <span class="tier-heading" i18n="@@interest_rate_percent">Interest<br />Rate (%)</span>
            <span class="tier-heading" i18n="@@compounding_frequency"
              >Compounding<br />Frequency</span
            >
            <span class="tier-heading" i18n="@@interest_payout">Interest<br />Payout</span>
            <span></span>
            <span class="tier-unit">{{ currencyCode }}</span>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact variant-header-select period-label-select"
            >
              <mat-label i18n="@@tenure">Tenure</mat-label>
              <mat-select formControlName="durationPeriodUnit">
                <mat-option *ngFor="let unit of recurringTenureUnitOptions" [value]="unit.value">{{ unit.label }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact variant-header-select period-label-select"
            >
              <mat-label i18n="@@period">Period</mat-label>
              <mat-select formControlName="interestRatePeriodUnit">
                <mat-option *ngFor="let unit of interestPeriodOptions" [value]="unit.value">{{ unit.label }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact variant-header-select period-label-select"
            >
              <mat-label i18n="@@period">Period</mat-label>
              <mat-select formControlName="compoundingFrequency">
                <mat-option *ngFor="let unit of recurringCompoundingOptions" [value]="unit.value">{{ unit.label }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="design-material-field compact variant-header-select period-label-select"
            >
              <mat-label i18n="@@period">Period</mat-label>
              <mat-select formControlName="interestPayout">
                <mat-option value="MONTH" i18n="@@monthOption">Month</mat-option>
                <mat-option value="QUARTER" i18n="@@quarter">Quarter</mat-option>
                <mat-option value="MATURITY" i18n="@@maturity">Maturity</mat-option>
              </mat-select>
            </mat-form-field>
            <ng-container *ngFor="let row of recurringTierRows">
              <span class="tier-row-label">{{ tierRowLabel(row.label) }} <strong>*</strong></span>
              <mat-form-field appearance="outline" class="design-material-field"
                ><input matInput appCurrency [formControlName]="row.amount"
              /></mat-form-field>
              <mat-form-field appearance="outline" class="design-material-field"
                ><input matInput appStrictNumbers [formControlName]="row.duration"
              /></mat-form-field>
              <mat-form-field appearance="outline" class="design-material-field"
                ><input matInput appDecimalNumbers [allowZero]="true" inputmode="decimal" [formControlName]="row.rate"
              /></mat-form-field>
              <mat-form-field
                appearance="outline"
                class="design-material-field variant-mirrored-field"
              >
                <input
                  matInput
                  readonly
                  [value]="getRecurringPeriodUnitLabel('compoundingFrequency')"
                />
              </mat-form-field>
              <mat-form-field
                appearance="outline"
                class="design-material-field variant-mirrored-field"
              >
                <input matInput readonly [value]="getRecurringPayoutLabel()" />
              </mat-form-field>
            </ng-container>
          </div>
        </article>

        <article
          class="recurring-settings-card"
          [class.monthly-frequency-card]="isMonthlySavingsFrequency"
        >
          <label *ngIf="isMonthlySavingsFrequency; else standardSavingsFrequency">
            <span i18n="@@savings_frequency">Savings Frequency</span>
            <div class="monthly-frequency-control">
              <mat-form-field
                appearance="outline"
                class="design-material-field monthly-frequency-select"
              >
                <mat-select formControlName="savingsFrequency">
                  <mat-option value="WEEKLY" i18n="@@weekly">Weekly</mat-option>
                  <mat-option value="MONTHLY" i18n="@@monthly">Monthly</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field
                appearance="outline"
                class="design-material-field monthly-day-field"
              >
                <input
                  matInput
                  type="text"
                  appStrictNumbers
                  formControlName="recurringDayOfMonth"
                  aria-label="Day of the month"
                  i18n-aria-label="@@day_of_month"
                />
              </mat-form-field>
              <small i18n="@@day_of_month_range">Day of the month (1 - 31)</small>
            </div>
          </label>
          <ng-template #standardSavingsFrequency>
            <label>
              <span i18n="@@savings_frequency">Savings Frequency</span>
              <mat-form-field
                appearance="outline"
                class="design-material-field recurring-setting-field"
              >
                <mat-select formControlName="savingsFrequency">
                  <mat-option value="WEEKLY" i18n="@@weekly">Weekly</mat-option>
                  <mat-option value="MONTHLY" i18n="@@monthly">Monthly</mat-option>
                </mat-select>
              </mat-form-field>
            </label>
          </ng-template>
          <label
            ><span i18n="@@contribution_source">Contribution Source</span
            ><mat-form-field
              appearance="outline"
              class="design-material-field recurring-setting-field"
              ><mat-select formControlName="contributionSource"
                ><mat-option value="AUTO_DEBIT" i18n="@@auto_debit_linked_account"
                  >Auto-debit Linked Account</mat-option
                ><mat-option value="MANUAL" i18n="@@manual_contribution"
                  >Manual Contribution</mat-option
                ></mat-select
              ></mat-form-field
            ></label
          >
          <label>
            <span class="setting-copy">
              <span i18n="@@grace_period">Grace Period</span>
              <small i18n="@@days_before_miss_recorded">Days before a miss is recorded</small>
            </span>
            <mat-form-field
              appearance="outline"
              class="design-material-field recurring-setting-field"
              ><input matInput appStrictNumbers formControlName="gracePeriod"
            /></mat-form-field>
          </label>
          <div class="bonus-setting-row">
            <label class="bonus-setting"
              ><span i18n="@@award_bonus_on_completion">Award a Bonus on Completion</span
              ><mat-slide-toggle
                class="figma-toggle"
                formControlName="awardCompletionBonus"
              ></mat-slide-toggle
            ></label>
            <div class="inline-material-fields">
              <mat-form-field appearance="outline" class="design-material-field bonus-type-field"
                ><mat-select formControlName="bonusType"
                  ><mat-option value="PERCENTAGE" i18n="@@percentage">Percentage</mat-option
                  ><mat-option value="FLAT" i18n="@@flat_amount"
                    >Flat Amount</mat-option
                  ></mat-select
                ></mat-form-field
              ><mat-form-field
                appearance="outline"
                class="design-material-field narrow percentage-field bonus-value-field"
                ><input matInput formControlName="bonusValue" /><span
                  *ngIf="recurringSavingsForm.get('bonusType').value === 'PERCENTAGE'"
                  class="percentage-symbol"
                  >%</span
                ></mat-form-field
              >
            </div>
          </div>
        </article>
      </div>

      <div class="recurring-secondary-grid">
        <div class="recurring-policy-stack">
          <article class="policy-card recurring-policy early-withdrawal-policy">
            <div class="policy-heading-row">
              <h3 i18n="@@allow_early_withdrawal">Allow Early Withdrawal</h3>
              <mat-slide-toggle
                class="figma-toggle"
                formControlName="allowEarlyWithdrawal"
              ></mat-slide-toggle>
            </div>
            <div class="early-withdrawal-body">
              <div class="early-lock-period">
                <span class="early-lock-copy"
                  ><span i18n="@@minimum_lock_period">Minimum Lock Period</span
                  ><small i18n="@@days_from_first_contribution"
                    >Days from first contribution</small
                  ></span
                ><mat-form-field
                  appearance="outline"
                  class="design-material-field early-control-field early-lock-field"
                  ><input matInput appStrictNumbers formControlName="maximumSavedPeriodDays"
                /></mat-form-field>
              </div>

              <div class="early-penalty-field">
                <span class="early-penalty-label" i18n="@@penalty_on_accrued_interest"
                  >Penalty on Accrued Interest</span
                ><mat-form-field
                  appearance="outline"
                  class="design-material-field early-control-field early-penalty-type"
                  ><mat-select formControlName="earlyWithdrawalPenaltyType"
                    ><mat-option value="PERCENTAGE" i18n="@@percentage">Percentage</mat-option
                    ><mat-option value="FLAT" i18n="@@flat_amount">Flat Amount</mat-option
                    ></mat-select
                  ></mat-form-field
                ><mat-form-field
                  appearance="outline"
                  class="design-material-field percentage-field early-control-field early-penalty-value"
                  ><input matInput formControlName="earlyWithdrawalPenaltyValue" /><span
                    *ngIf="
                      recurringSavingsForm.get('earlyWithdrawalPenaltyType').value ===
                      'PERCENTAGE'
                    "
                    class="percentage-symbol"
                    >%</span
                  ></mat-form-field
                >
              </div>
            </div>
          </article>
          <article class="policy-card recurring-policy missed-contribution-policy">
            <div class="policy-heading-row">
              <h3 i18n="@@missed_contribution">Missed Contribution</h3>
            </div>
            <div class="recurring-policy-body">
              <div class="policy-control-row">
                <span i18n="@@penalty_per_missed_contribution"
                  >Penalty per Missed Contribution</span
                >
                <div class="inline-material-fields">
                  <mat-form-field appearance="outline" class="design-material-field type-field"
                    ><mat-select formControlName="missedContributionPenaltyType"
                      ><mat-option value="PERCENTAGE" i18n="@@percentage">Percentage</mat-option
                      ><mat-option value="FLAT" i18n="@@flat_amount"
                        >Flat Amount</mat-option
                      ></mat-select
                    ></mat-form-field
                  ><mat-form-field
                    appearance="outline"
                    class="design-material-field percentage-field"
                    ><input matInput formControlName="missedContributionPenaltyValue" /><span
                      *ngIf="
                        recurringSavingsForm.get('missedContributionPenaltyType').value ===
                        'PERCENTAGE'
                      "
                      class="percentage-symbol"
                      >%</span
                    ></mat-form-field
                  >
                </div>
              </div>
              <label class="toggle-row"
                ><span i18n="@@forfeit_bonus_on_any_missed_contribution"
                  >Forfeit bonus on completion after any missed contribution</span
                ><mat-slide-toggle
                  class="figma-toggle"
                  formControlName="forfeitBonusOnMissedContribution"
                ></mat-slide-toggle
              ></label>
            </div>
          </article>
          <article class="policy-card gl-card">
            <h3 i18n="@@at_completion">At Completion</h3>
            <mat-form-field appearance="outline" class="design-material-field"
              ><mat-select formControlName="glTemplate"
                ><mat-option
                  value="USE_LINKED_SAVINGS_ACCOUNT"
                  i18n="@@transfer_to_linked_savings_account"
                  >Transfer to Linked Savings Account</mat-option
                ></mat-select
              ></mat-form-field
            >
          </article>
        </div>

        <article class="calculator-card recurring-calculator" [formGroup]="recurringSavingsForm">
          <p>
            <strong i18n="@@live_calculator">Live Calculator</strong>
          </p>
          <label
            ><span i18n="@@target_amount_required">Target Amount <strong>*</strong></span
            ><mat-form-field appearance="outline" class="design-material-field calculator-field"
              ><input matInput appCurrency formControlName="calculatorTargetAmount" /></mat-form-field
          ></label>
          <label
            ><span i18n="@@duration_unit_required">Duration ({{ recurringTenureUnitLabel() }}) <strong>*</strong></span
            ><mat-form-field appearance="outline" class="design-material-field calculator-field"
              ><input matInput appStrictNumbers inputmode="numeric" formControlName="calculatorDuration" /></mat-form-field
          ></label>
          <label
            ><span i18n="@@interest_rate_per_month_required"
              >Interest Rate (per month) <strong>*</strong></span
            ><mat-form-field appearance="outline" class="design-material-field calculator-field"
              ><input matInput appDecimalNumbers [allowZero]="true" inputmode="decimal" formControlName="calculatorInterestRate" /></mat-form-field
          ></label>
          <label
            ><span i18n="@@contribution_per_period">Contribution per Period</span
            ><mat-form-field
              appearance="outline"
              class="design-material-field projected-interest-field"
              ><input
                matInput
                readonly
                [value]="formatProjectionAmount(recurringCalculatorResult?.contributionPerPeriod)"
              /></mat-form-field
          ></label>
          <div class="recurring-projected-interest-group">
            <label
              ><span i18n="@@projected_interest_earned">Projected Interest Earned</span
              ><mat-form-field
                appearance="outline"
                class="design-material-field projected-interest-field"
                ><input
                  matInput
                  readonly
                  [value]="formatProjectionAmount(recurringCalculatorResult?.projectedInterestEarned)"
                /></mat-form-field
            ></label>
            <div class="calculator-note" i18n="@@recurring_interest_calculation_note">
              Approximated; actual interest accrual depends on exact contribution dates.
            </div>
          </div>
          <label
            ><span i18n="@@projected_balance_at_completion">Projected Balance at Completion</span
            ><mat-form-field
              appearance="outline"
              class="design-material-field projected-interest-field"
              ><input
                matInput
                readonly
                [value]="formatProjectionAmount(recurringCalculatorResult?.projectedBalanceAtCompletion)"
              /></mat-form-field
          ></label>
        </article>
      </div>
    </section>

    <section class="figma-panel product-information-section" [formGroup]="productInfoForm">
      <h3 i18n="@@other_deposit_product_information">Other Deposit Product Information</h3>
      <div class="product-information-row">
        <mat-form-field
          appearance="outline"
          class="design-material-field floated-design-field collection-account-field"
          [hideRequiredMarker]="true"
        >
          <mat-label>
            <span i18n="@@collection_accounts">Collection Account(s)</span>
            <strong>*</strong>
          </mat-label>
          <mat-select multiple formControlName="fundSources">
            <mat-select-trigger>
              <span
                class="collection-account-chip"
                *ngFor="let id of productInfoForm.get('fundSources').value"
              >
                {{ fundSourceName(id) }}
                <button
                  type="button"
                  class="collection-account-chip-remove"
                  (click)="removeFundSource(id, $event)"
                  [attr.aria-label]="'Remove ' + fundSourceName(id)"
                >
                  &times;
                </button>
              </span>
            </mat-select-trigger>
            <mat-option *ngFor="let source of fundSources" [value]="source.id">
              {{ source.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="design-material-field floated-design-field calculation-basis-field"
        >
          <mat-label i18n="@@calculation_basis">Calculation Basis</mat-label>
          <mat-select formControlName="calculationBasis">
            <mat-option *ngFor="let basis of calculationBases" [value]="basis.value">
              {{ basis.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          *ngIf="isWorkingDaysBasis"
          appearance="outline"
          class="design-material-field floated-design-field weekends-field"
        >
          <mat-label i18n="@@weekends">Weekends</mat-label>
          <mat-select formControlName="weekends">
            <mat-option *ngFor="let weekend of weekendOptions" [value]="weekend.value">
              {{ weekend.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          floatLabel="always"
          class="design-material-field floated-design-field rounding-multiple-field"
        >
          <mat-label i18n="@@rounding_multiple">Rounding Multiple</mat-label>
          <input
            matInput
            type="text"
            appStrictNumbers
            class="currency-value"
            formControlName="roundingMultiple"
          />
        </mat-form-field>
      </div>
    </section>

    <section class="figma-panel channels-section" [formGroup]="channelsForm">
      <h3 i18n="@@channels">Channels</h3>
      <div class="channels-row">
        <div class="channel-card" *ngFor="let channel of channelOptions">
          <img [src]="channel.icon" alt="" />
          <span>{{ channel.label }}</span>
          <mat-slide-toggle
            class="figma-toggle"
            [formControlName]="channel.control"
          ></mat-slide-toggle>
        </div>
      </div>
    </section>

    <section class="fee-section">
      <h3 i18n="@@fees_charges">Fees &amp; Charges</h3>
      <app-fee-charge-config
        [charges]="charges"
        [isDisabled]="isDisabled"
        [rows]="feeChargeRows"
        [feeEventTypes]="feeEventTypes"
        [nameHeader]="feeChargeNameHeader"
        (rowsChange)="syncFeeCharges($event)"
      ></app-fee-charge-config>
    </section>

    <section class="accounting-section">
      <app-drag-drop-list
        [product]="'deposit'"
        [isDisabled]="isDisabled"
        [accountingCategories]="accountingCategories"
        [glAccounts]="glAccounts"
        [events]="events"
        [charges]="charges"
        [eventMaps]="eventMaps"
        [accountType]="activeAccountType"
        [feeChargeRows]="feeChargeRows"
        (emitAccountingList)="submit($event)"
      ></app-drag-drop-list>
    </section>

    <footer class="modal-actions">
      <app-button-icon-ui
        *ngIf="showApprovalActions"
        [buttonType]="'button'"
        classNames="px-[33px] py-[14px] rounded-[10px] border border-error opacity-80 hover:opacity-100 text-error w-[120px] h-[45px]"
        (clickEmit)="approveRejectDepositProduct('REJECTED')"
        i18n-name="@@reject"
        name="Reject"
        value="reject"
      ></app-button-icon-ui>
      <app-button-icon-ui
        *ngIf="showApprovalActions"
        [buttonType]="'button'"
        classNames="px-[33px] py-[14px] rounded-[10px] text-white bg-success/90 hover:bg-success w-[120px] h-[45px]"
        (clickEmit)="approveRejectDepositProduct('APPROVED')"
        i18n-name="@@approve"
        name="Approve"
        value="approve"
      ></app-button-icon-ui>
      <app-button-icon-ui
        *ngIf="isViewMode && isDisabled && canEdit"
        [buttonType]="'button'"
        classNames="px-[33px] py-[14px] rounded-[10px] text-white bg-success/90 hover:bg-success w-[120px] h-[45px]"
        (clickEmit)="editForm($event)"
        i18n-name="@@editButton"
        name="Edit"
        value="edit"
      ></app-button-icon-ui>
      <app-button-icon-ui
        *ngIf="isViewMode && !isDisabled && canEdit"
        [buttonType]="'button'"
        classNames="px-[33px] py-[14px] rounded-[10px] text-white bg-success/90 hover:bg-success w-[120px] h-[45px]"
        (clickEmit)="editForm($event)"
        i18n-name="@@saveButton"
        name="Save"
        value="save"
      ></app-button-icon-ui>
      <app-button-icon-ui
        *ngIf="!isViewMode"
        [buttonType]="'button'"
        classNames="px-[33px] py-[14px] rounded-[10px] text-white bg-success/90 hover:bg-success w-[120px] h-[45px]"
        (clickEmit)="submitForm()"
        i18n-name="@@submitButton"
        name="Submit"
        value="submit"
      ></app-button-icon-ui>
      <app-button-icon-ui
        [buttonType]="'button'"
        classNames="px-[33px] py-[14px] rounded-[10px] border border-error opacity-80 hover:opacity-100 text-error w-[120px] h-[45px]"
        (clickEmit)="cancel()"
        i18n-name="@@cancel"
        name="Cancel"
        value="cancel"
      ></app-button-icon-ui>
    </footer>
  </main>
</div>
